export class FaqSearcher {
    constructor(faqs) {
        this.faqs = faqs;
    }

    search(query) {
        if (!query || query === 'undefined' || query.length <= 0) return []

        const questions = this._getQuestions()
        const filtered = this._filterQuestions(questions, query)
        return filtered.slice(0, 4) // max 5 results
    }

    _getQuestions() {
        return this.faqs.map(i => i.questions).flat()
    }

    _filterQuestions(questions, query) {
        query = query.toLowerCase()
        return questions.filter(
            q => {
                return q.question.toLowerCase().includes(query)
                    || q.answer.toLowerCase().includes(query)
            }
        )
    }
}